import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "antd/lib/modal";
import Tooltip from "antd/lib/tooltip";
import config1 from "../../config";
import IsDarkPost from "../../assets/Dark_Post.svg";
import shareQ from "../../assets/share_q.svg";
import shareQwhite from "../../assets/share_q_white.svg";
import Interaction from "../../assets/WidgetMaker/Interaction.svg";
import deepLinkIcon from "../../assets/deepLink_Icon.svg";
import deepLinkIconCC from "../../assets/CommandCenter/ticketDetails_commandcenter.svg";
import FB_Like from "../../assets/FB_Like.svg";
import FB_like_white from "../../assets/deepDive/FB_like_white.svg";
import upvote from "../../assets/upvote.svg";
import upvotewhite from "../../assets/upvote_white.svg";
import fb_share from "../../assets/fb_share.svg";
import fb_share_white from "../../assets/fb_share_white.svg";
import instaShare from "../../assets/insta_share.svg";
import instaShareWhite from "../../assets/insta_share_white.svg";
import Youtube_Share from "../../assets/Youtube_Share.svg";
import Youtube_Share_white from "../../assets/Youtube_Share_white.svg";
import Video_view from "../../assets/Video_view.svg";
import Video_view_white from "../../assets/Video_view_white.svg";
import trendsIcon from "../../assets/Trend.svg";
import fx from "../../assets/WidgetMaker/FX.svg";
import trendsIconCC from "../../assets/CommandCenter/trending_up-24px_commandcenter.svg";
import reTweet from "../../assets/deepDive/reTweet.svg";
import reTweetwhite from "../../assets/deepDive/reTweet_white.svg";
import like from "../../assets/deepDive/Like.svg";
import likewhite from "../../assets/deepDive/Like_white.svg";
import comment from "../../assets/deepDive/comment.svg";
import commentwhite from "../../assets/deepDive/comment_white.svg";
import postClickWhite from "../../assets/white_post_click_icon.svg";
import postClickBlack from "../../assets/black_post_click_icon.svg";
import Delete from "../../assets/CommandCenter/Delete.svg";
import Globe from "../../assets/CommandCenter/Globe.svg";
import ViewIcon from "../../assets/CommandCenter/hidden.svg";
import Clock from "../../assets/Clock.svg";
import moneyBagIcon from "../../assets/money-bag-icon.svg";
import moneyBagIconWhite from "../../assets/money-bag-icon-white.svg";
import TrandsView from "./TrandsView";
import saved from "../../assets/deepDive/Saved.svg";
import white_Saved from "../../assets/deepDive/white_Saved.svg";
import {
  setWidgetMakerPostCardTrends,
  setWidgetMakerTrandArray,
  setWidgetMakerPostCardShareTrends,
  setDashboardTrendsFlag,
  getUnmaskedInfo,
  setUnmaskedInfo,
  getDeepDive,
} from "../../redux/actions/WidgetMaker/WidgetAPI";
import userFollowers from "../../assets/FollowersBlue.svg";
import {
  callNotification,
  getAllFilters,
  getAllShareFilters,
  getBrands,
  getCustomizedDate,
  getPaneIndex,
  getWindowLocationPath,
  kFormatter,
  useQuery,
} from "../../redux/constants";

import isEqual from "react-fast-compare";
import { setOptionHighChart } from "../../redux/actions/HighChart";
import { setOnClickGlobeCoordinates } from "../../redux/actions/commandCenter/screens/screen";
import DeletePost from "./CustomCard/DeletePost";
import MarkInfluencerPost from "./CustomCard/MarkInfluencerPost";
import { getInfluencersList } from "../../redux/actions/commandCenter/commandCenterApi";
import MarkInfluencerIcon from "../../assets/CommandCenter/mark_influencer_icon.svg";
import MarkInfluencerBlueIcon from "../../assets/CommandCenter/mark_influencer_blue_icon.svg";
import MarkInfluencerBlueIconCC from "../../assets/CommandCenter/mark_influencer_blue_icon_commandcenter.svg";
import MarkInfluencerYellowIcon from "../../assets/CommandCenter/yellow_mark_Influencer_icon.svg";
import MaskIconCC from "../../assets/CommandCenter/disabled_visible_blue_commandcenter.svg";
import Maskimg from "../../assets/disabled_visible_blue.svg";
import UnMaskimg from "../../assets/disabled_visible_gray.svg";
import UnMaskIconCC from "../../assets/CommandCenter/disabled_visible_gray_commandcenter.svg";
import "./PostCardFooter.scss";
import { getDynamicChannelIcon } from "../../redux/constants/ChannelIcons";
import { getDynamicIconColor } from "../../redux/constants/DynamicIconColor";

import {
  setDeepDiveInfoLoader,
  setIsDetailedInsightVisible,
  setTabClick,
} from "../../redux/actions/DeepDive";
import {
  set_WM_DeepDive,
  setDeepDiveInfluencersObject,
  setDeepDiveMentionsObject,
  setDeepDiveObject,
} from "../../redux/actions/WidgetMaker/WidgetMaker";
import {
  setisDeepDive,
  setIsProlificUserDeepDive,
  setSelectedDeepdiveWidget,
} from "../../redux/actions/dashboard/Tab1";
import { setShareSelectedDeepdiveWidget } from "../../redux/actions/share/Share";
import moment from "moment";
const PostCardFooter = ({
  isPreviewState,
  data,
  PdfDownloadStatus,
  PptGeneratingStatus,
  el,
  postDetail,
  deepDive,
  isReviewCard,
  isNetworkTooltip,
  isDarkBackground,
  qrChannel,
  pantipChannel,
  section_index,
  widget_index,
  isTwitterTrendScreen,
  highlightWord,
  isDeepDiveDashboardView = false,
}) => {
  let query = useQuery();
  const dispatch = useDispatch();
  const authParams = useSelector((state) => state.Authentication.authParams);
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const screen = useSelector((state) => state?.Screens?.screen);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state.Tab1.activeKey);
  const index = getPaneIndex(panes, activeKey);
  const isDashboardScheduleModal = useSelector(
    (state) => state?.ApiCall?.is_dashboard_schedule_modal
  );
  const unMaskedInfo = useSelector((state) => state.ApiCall.unMaskedInfo);
  const unMaskedInfoId = useSelector((state) => state.ApiCall.unMaskedInfoId);

  const shareCategory = useSelector((state) => state.ApiCall.shareCategory);
  const sharedDuration = useSelector((state) => state.Share.sharedDuration);

  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);

  const allAttributes = useSelector(
    (state) => state?.attributes?.allAttributes
  );
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const workspace_privileges = useSelector(
    (state) => state.ApiCall.workspace_privileges
  );
  const share_workspace_privileges = useSelector(
    (state) => state.ApiCall.share_workspace_privileges
  );

  const [deepLinkModal, setDeepLinkModal] = useState({
    url: null,
    modalShow: false,
  });
  const [getunmaskedInfo, setGetunmaskedInfo] = useState(false);
  const [masked, setMasked] = useState(
    unMaskedInfo !== null
      ? unMaskedInfo.tagids.includes(el?.TagID)
        ? false
        : true
      : true
  );
  const [trendValue, setTrendvalue] = useState(null);
  const [trandView, setTrandView] = useState({
    modalShow: false,
    data: null,
  });
  const [deletePost, setDeletePost] = useState({
    modalShow: false,
    data: null,
  });
  const [markInfluencer, setMarkInfluencer] = useState({
    modalShow: false,
    data: null,
  });

  let mention = authParams?.screen_id
    ? screen?.deep_dive
    : shareTemplateData
    ? shareTemplateData?.deep_dive
    : panes?.[index]?.deep_dive;

  let widget_metadata =
    section_index >= 0
      ? panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
      : panes?.[index]?.section?.[0]?.widgets?.[widget_index];

  const handleTrends = (e, id, widgetmakerPostCardTrands) => {
    let timer1 = null;
    let timer2 = null;
    dispatch(setDashboardTrendsFlag(true));
    setTrendvalue(e);
    if (shareTemplateData) {
      const d = new Date();
      let utcOffset = d.getTimezoneOffset();
      let tab_array = [
        { widget_id: 0, chart_type: "user_profile", widget_loader: true },
        { widget_id: 1, chart_type: "kpi", widget_loader: true },
        { widget_id: 2, chart_type: "line", widget_loader: true },
        { widget_id: 3, chart_type: "donut", widget_loader: true },
        { widget_id: 4, chart_type: "wordcloud", widget_loader: true },
      ];
      dispatch(setWidgetMakerTrandArray(tab_array));

      setTrandView({
        modalShow: true,
        data: e,
      });
      tab_array = tab_array?.map((el, i) => {
        let obj = {
          ...el,
          card_type: e?.card_type,
          content_id: e?.PostContentID,
          brand_id: e?.PostBrandID,
          author_id: e?.AuthorAuthorID,
          post_id: e?.PostPostID,
          retweet_id: e?.RetweetedStatusID,
          reply_id: e?.InReplytostatusID,
          channel_group_id: e?.PlatformID,
          tag_id: e?.TagID,
          utcOffset: utcOffset,
          offset: 0,
          isVerified: 0,
          sentimentType: {
            ispositive: 0,
            isnegative: 0,
            isneutral: 0,
          },
          trends_duration: el?.widget_id === 2 ? "eight_hours" : 0,
          isreply: 0,
          isretweet: 0,
          isreplywmedia: 0,
          attribute: "followers",
          sort_order: "desc",
          uniqueid: e?.uniqueid,
        };
        return obj;
      });
      timer1 = setTimeout(() => {
        tab_array?.forEach((el) => {
          shareCategory?.id &&
            dispatch(
              setWidgetMakerPostCardShareTrends(shareCategory, el, tab_array)
            );
        });
      }, 200);
    } else {
      const d = new Date();
      let utcOffset = d.getTimezoneOffset();
      let tab_array = widgetmakerPostCardTrands
        ? [...widgetmakerPostCardTrands]
        : [
            { widget_id: 0, chart_type: "user_profile", widget_loader: true },
            { widget_id: 1, chart_type: "kpi", widget_loader: true },
            { widget_id: 2, chart_type: "line", widget_loader: true },
            { widget_id: 3, chart_type: "donut", widget_loader: true },
            { widget_id: 4, chart_type: "wordcloud", widget_loader: true },
          ];

      //high chart option data clear start
      let updateOpData = global.options ? { ...global.options } : {};
      tab_array?.map((el) => {
        if (updateOpData?.[el?.chart_type]) delete updateOpData[el?.chart_type];
      });
      dispatch(setOptionHighChart(updateOpData));
      //high chart option data clear end
      // if (
      //   e?.PlatformID === 3 &&
      //   e?.card_type === "User Post" &&
      //   !widgetmakerPostCardTrands
      // ) {
      //   let arr = tab_array.filter((el, i) => {
      //     if (i < 2) return el;
      //   });
      //   tab_array = arr;
      //   dispatch(setWidgetMakerTrandArray(arr));
      // }
      if (e?.card_type === "Brand Post" && !widgetmakerPostCardTrands) {
        let arr = tab_array.filter((el, i) => {
          if (i > 0) return el;
        });
        tab_array = arr;
        dispatch(setWidgetMakerTrandArray(arr));
      }
      dispatch(setWidgetMakerTrandArray(tab_array));
      setTrandView({
        modalShow: true,
        data: e,
      });
      tab_array = !widgetmakerPostCardTrands
        ? tab_array?.map((el, i) => {
            let obj = {
              ...el,
              card_type: e?.card_type,
              content_id: e?.PostContentID,
              brand_id: e?.PostBrandID,
              author_id: e?.AuthorAuthorID,
              post_id: e?.PostPostID,
              retweet_id: e?.RetweetedStatusID,
              reply_id: e?.InReplytostatusID,
              channel_group_id: e?.PlatformID,
              tag_id: e?.TagID,
              utcOffset: utcOffset,
              offset: 0,
              isVerified: 0,
              sentimentType: {
                ispositive: 0,
                isnegative: 0,
                isneutral: 0,
              },
              trends_duration: el?.widget_id === 2 ? "eight_hours" : 0,
              isreply: 0,
              isretweet: 0,
              isreplywmedia: 0,
              attribute: "followers",
              sort_order: "desc",
              uniqueid: e?.uniqueid,
            };
            return obj;
          })
        : tab_array;
      if (e?.PlatformID === 3 && e?.card_type === "User Post" && false) {
        tab_array?.forEach((el) => {
          authParams &&
            dispatch(setWidgetMakerPostCardTrends(authParams, el, tab_array));
        });
      } else {
        timer2 = setTimeout(() => {
          tab_array?.forEach((el) => {
            authParams &&
              dispatch(setWidgetMakerPostCardTrends(authParams, el, tab_array));
          });
        }, 200);
        // tab_array?.[
        //   id
        //     ? e?.card_type === "Brand Post"
        //       ? parseInt(id) - 1
        //       : parseInt(id)
        //     : 0
        // ]?.widget_id >= 0 &&
        //   authParams &&
        //   dispatch(
        //     setWidgetMakerPostCardTrends(
        //       authParams,
        //       tab_array[
        //         id
        //           ? e?.card_type === "Brand Post"
        //             ? parseInt(id) - 1
        //             : parseInt(id)
        //           : 0
        //       ],
        //       tab_array
        //     )
        //   );
      }
    }
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  };
  const onExternal = (TicketID, PostBrandID) => {
    setDeepLinkModal({
      url: null,
      modalShow: true,
    });
    let url =
      config1?.config1?.app_id === "10" || config1?.config1?.app_id === 10
        ? "https://preprodcx.locobuzz.com/ticketDetail"
        : config1?.config1?.app_id === "6" || config1?.config1?.app_id === 6
        ? window?.location?.origin?.includes("bbps.locobuzz.com") ||
          window?.location?.ancestorOrigins?.[0]?.includes("bbps.locobuzz.com")
          ? "https://bbps.locobuzz.com/ticketDetail"
          : "https://cx.locobuzz.com/ticketDetail"
        : config1?.config1?.app_id === "4" || config1?.config1?.app_id === 4
        ? window?.location?.origin?.includes("demo.locobuzz.com")
          ? "https://demo.locobuzz.com/ticketDetail"
          : window?.location?.origin?.includes(
              "locobuzzng-uat-aws.locobuzz.com"
            ) ||
            window?.location?.ancestorOrigins?.[0]?.includes(
              "locobuzzng-uat-aws.locobuzz.com"
            )
          ? "https://locobuzzng-uat-aws.locobuzz.com/ticketDetail"
          : "https://demo.locobuzz.com/ticketDetail"
        : "https://demo.locobuzz.com/ticketDetail";
    // : "https://demo.locobuzz.com/ticketDetail";

    let finalUrl = `${url}/${TicketID}/${PostBrandID}`;
    if (config1?.config1?.app_id === "2") {
      console.log("Deep Link URL =>", finalUrl);
    }
    // window.open(finalUrl);

    setDeepLinkModal({
      url: (
        <iframe
          title="Ticket Details"
          allowfullscreen={true}
          src={finalUrl}
          alt="Ticket Details"
          className="w-100 border-0 border-radius-4"
          style={{ height: "calc(100vh - 6.3rem)", marginTop: "3.7rem" }}
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        />
      ),
      modalShow: true,
    });
  };
  const handleDeepLinkOk = () => {
    setDeepLinkModal({
      url: null,
      modalShow: false,
    });
  };
  const handleDeepLinkCancel = () => {
    setDeepLinkModal({
      url: null,
      modalShow: false,
    });
  };

  const handleGlobeClick = (el) => {
    let data = {
      latitude: el.latitude,
      longitude: el.longitude,
      sentimentType: el.SentimentType,
    };
    dispatch(setOnClickGlobeCoordinates(data));
  };
  const commandCenter3DGlobePageId =
    authParams?.screen_id === "000-000-555" && !isDeepDiveDashboardView
      ? true
      : false;
  const commandCenterInfluencersPageId =
    authParams?.screen_id === "000-000-553" && !isDeepDiveDashboardView
      ? true
      : false;

  const handleMarkInfluencerModal = (data) => {
    let payloadObject = {
      brandFriendlyName: data?.BrandFriendlyName,
      brandID: data?.PostBrandID,
      brandName: data?.BrandName,
    };
    // Call Influencer list API
    dispatch(getInfluencersList(payloadObject));

    setMarkInfluencer({
      modalShow: true,
      data: data,
    });
  };
  const idPresentFlag = unMaskedInfo?.tagids?.includes(el?.TagID);
  const handleMaskUnMask = () => {
    // setMasked(masked === true ? false : true);
    setMasked(!masked);

    const PostCardDetails = {
      TagID: el?.TagID,
      PostBrandID: el?.PostBrandID,
      BrandName: el?.BrandName,
      ptoken: authParams?.ptoken,
      el: el,
      unMaskedInfoId: unMaskedInfoId,
      unMaskedInfo: unMaskedInfo,
    };
    if (masked) {
      dispatch(setUnmaskedInfo(PostCardDetails)); //To handle tagids array for idpresentflag
      if (!getunmaskedInfo) {
        dispatch(getUnmaskedInfo(PostCardDetails)); //Main api call to back end
        setGetunmaskedInfo(true); // Flag to not call api to  multiple times
      }
    } else {
      dispatch(setUnmaskedInfo(PostCardDetails)); //To handle tagids array for idpresentflag
    }
  };
  const handleDeletePostModal = (data) => {
    setDeletePost({
      modalShow: true,
      data: data,
    });
  };
  const isDarkTheme = useMemo(() => {
    return isNetworkTooltip
      ? isDarkBackground
        ? true
        : false
      : authParams?.theme_type === "1";
  }, [authParams?.theme_type, isNetworkTooltip, isDarkBackground]);

  const handleProlificUserDeepDive = (el) => {
    let pathName = getWindowLocationPath()?.toLowerCase();
    if (isDeepDiveDashboardView) {
      callNotification(
        "Action not allowed inside attribute based deep-dive.",
        "info"
      );
    } else if (
      pathName === "widgetMaker"?.toLowerCase() ||
      pathName === "edit-widget"?.toLowerCase() ||
      isPreviewState ||
      ((pathName === "dashboard" || pathName === "pin-dashboard") &&
        panes?.[getPaneIndex(panes, activeKey)]?.is_widget_maker_open_obj
          ?.open_flag)
    ) {
      callNotification(
        "Action is allowed only from the dashboard view.",
        "info"
      );
    } else if (
      el?.Interaction > 1 &&
      (panes[getPaneIndex(panes, activeKey)]?.isDashboard || shareBrands)
    ) {
      let widget_ids = ["info-bar", "1.1"];
      // let widget_ids = ["info-bar", "2.1", "2.2", "2.3", "2.4"];

      let index = getPaneIndex(panes, activeKey);
      let shareSections = shareTemplateData?.section
        ? shareTemplateData?.section[0]
        : shareTemplateData?.sections[section_index];
      let widget_metadata = shareBrands
        ? shareSections?.widgets?.[widget_index]
        : section_index >= 0
        ? panes[index]?.sections[section_index]?.widgets[widget_index]
        : panes[index]?.section[0]?.widgets[widget_index];

      let section_metadata = shareBrands
        ? shareSections
        : section_index >= 0
        ? panes[index]?.sections[section_index]
        : panes[index]?.section[0];
      let Section_is_locked = section_metadata?.is_locked;
      let widgets_is_locked = widget_metadata?.is_locked;
      let twoMonthsDuration = getCustomizedDate(6, "Days");
      let defaultDuration = {
        from:
          moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
          " " +
          twoMonthsDuration?.time?.startTime,
        to:
          moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
          " " +
          twoMonthsDuration?.time?.endTime,
      };

      !shareBrands &&
        dispatch(
          setSelectedDeepdiveWidget(section_index, widget_index, panes, index)
        );

      shareBrands &&
        dispatch(
          setShareSelectedDeepdiveWidget({
            section_index: section_index,
            widget_index: widget_index,
          })
        );

      let global_duration = shareBrands
        ? sharedDuration?.from
          ? {
              from: sharedDuration?.from,
              to: sharedDuration?.to,
            }
          : null
        : panes[index]?.duration;

      let global_brands = shareBrands ? shareBrands : panes?.[index]?.brands;
      let brandIds = shareBrands
        ? widget_metadata?.brand_ids
        : section_index >= 0
        ? panes[index]?.sections[section_index]?.widgets &&
          panes[index]?.sections[section_index]?.widgets[widget_index]
            ?.brand_ids
        : panes[index]?.section[0]?.widgets[widget_index]?.brand_ids
        ? panes[index]?.section[0]?.widgets[widget_index]?.brand_ids
        : null;

      let sectionDateFilter = shareTemplateData?.sections
        ? {
            from: shareTemplateData?.sections[section_index]?.start_date
              ? shareTemplateData?.sections[section_index]?.start_date
              : null,
            to: shareTemplateData?.sections[section_index]?.end_date
              ? shareTemplateData?.sections[section_index]?.end_date
              : null,
          }
        : null;

      let widgetFilterDate = {
        from: widget_metadata?.start_date ? widget_metadata?.start_date : null,
        to: widget_metadata?.end_date ? widget_metadata?.end_date : null,
      };

      let combinedFilters = [];
      if (!widget_metadata?.is_locked) {
        if (widgetFilterDate?.from)
          combinedFilters.push({
            attribute: "createddate",
            type: "datetime",
            columns: widgetFilterDate,
          });

        if (sectionDateFilter?.from && !section_metadata?.is_locked) {
          combinedFilters.push({
            attribute: "createddate",
            type: "datetime",
            columns: sectionDateFilter,
          });
        }
        if (section_metadata?.brand_ids && !section_metadata?.is_locked) {
          let brands = getBrands(
            shareBrands?.brand_groups,
            section_metadata?.brand_ids,
            shareBrands?.brand_list,
            section_metadata?.brand_groups
          );

          combinedFilters.push(brands);
        }
        if (widget_metadata?.brand_ids) {
          let brands = getBrands(
            shareBrands?.brand_groups,
            widget_metadata?.brand_ids,
            shareBrands?.brand_list,
            widget_metadata?.brand_groups
          );

          combinedFilters.push(brands);
        }
      }

      if (widget_metadata?.filters)
        combinedFilters = [...widget_metadata?.filters, ...combinedFilters];
      if (section_metadata?.filters)
        combinedFilters = [...section_metadata?.filters, ...combinedFilters];
      let filterData = combinedFilters?.filter((d) => d);
      let hidden_filter = shareTemplateData?.hidden_filter
        ? [shareTemplateData?.hidden_filter]
        : [];
      let quick_filter = shareTemplateData?.quick_filter
        ? [shareTemplateData?.quick_filter]
        : [];

      let filter = shareBrands
        ? getAllShareFilters(
            graphConditionConfig,
            shareTemplateData,
            section_index,
            widget_index,
            shareBrands
          )
        : getAllFilters(
            graphConditionConfig,
            panes,
            index,
            section_index,
            widget_index,
            brandlogicalgroup,
            brandIds
          );

      let widget_brands = shareBrands
        ? getBrands(
            shareBrands?.brand_groups,
            widget_metadata?.brand_ids,
            shareBrands?.brand_list,
            widget_metadata?.brand_groups
          )
        : getBrands(
            brandlogicalgroup,
            widget_metadata?.brand_ids,
            brands,
            widget_metadata?.brand_groups
          );
      let section_brands = shareBrands
        ? getBrands(
            shareBrands?.brand_groups,
            section_metadata?.brand_ids,
            shareBrands?.brand_list,
            section_metadata?.brand_groups
          )
        : getBrands(
            brandlogicalgroup,
            section_metadata?.brand_ids,
            brands,
            section_metadata?.brand_groups
          );
      let defaultBrands = shareBrands ? shareBrands : null;

      // This case is applied when we select competition brand and applied competition filter(Owned/Competition)
      // calculating brand in case of section comprtiotion brand type exists

      let sectionComprtitorBrandType =
        section_metadata?.comp_brand_type === false ||
        section_metadata?.comp_brand_type === true
          ? section_metadata?.comp_brand_type
          : null;
      let sectionComprtitorBrandTypeExists =
        sectionComprtitorBrandType === false ||
        sectionComprtitorBrandType === true;
      let updatedComBrandList = [];
      if (
        !(Section_is_locked && section_brands?.columns?.length) &&
        sectionComprtitorBrandTypeExists
      ) {
        if (shareBrands) {
          let comBrand = defaultBrands?.brands?.columns?.[0]?.competitor
            ? defaultBrands?.brands?.columns?.[0]
            : defaultBrands?.brands?.[0]?.competitor
            ? defaultBrands?.brands?.[0]
            : defaultBrands?.brands?.competitor
            ? defaultBrands?.brands
            : null;
          let comBrandExists = comBrand?.competitor
            ? true
            : defaultBrands
            ? defaultBrands?.selected_brand_ids?.length &&
              defaultBrands?.selected_comp_brand_ids?.length > 0
            : null;
          if (comBrandExists) {
            if (comBrand) {
              if (sectionComprtitorBrandType === false) {
                updatedComBrandList.push({
                  brand_id: comBrand?.name,
                  brand_name: comBrand?.brand_name,
                  brand_friendly_name: comBrand?.brand_friendly_name,
                });
              } else {
                comBrand?.competitorList?.forEach((competitorBrand) => {
                  updatedComBrandList.push(competitorBrand);
                });
              }
            } else {
              if (sectionComprtitorBrandType === false) {
                let parentB = defaultBrands?.selected_brand_ids?.[0];
                updatedComBrandList.push({
                  brand_id: parentB?.brand_id,
                  brand_name: parentB?.brand_name,
                  brand_friendly_name: parentB?.brand_friendly_name,
                });
              } else {
                defaultBrands?.selected_comp_brand_ids?.forEach(
                  (competitorBrand) => {
                    updatedComBrandList.push(competitorBrand);
                  }
                );
              }
            }
          } else {
            sectionComprtitorBrandTypeExists = false;
          }
        } else {
          let comBrand = global_brands?.columns?.[0]?.competitor
            ? global_brands?.columns?.[0]
            : global_brands?.[0]?.competitor
            ? global_brands?.[0]
            : global_brands?.competitor
            ? global_brands
            : null;
          if (comBrand?.competitor) {
            if (sectionComprtitorBrandType === false) {
              updatedComBrandList.push({
                brand_id: comBrand?.name,
                brand_name: comBrand?.brand_name,
                brand_friendly_name: comBrand?.brand_friendly_name,
              });
            } else {
              comBrand?.competitorList?.forEach((competitorBrand) => {
                updatedComBrandList.push(competitorBrand);
              });
            }
          } else {
            sectionComprtitorBrandTypeExists = false;
          }
        }
      }

      let graphObject = {
        start_date: widgets_is_locked
          ? widget_metadata?.start_date
            ? widget_metadata?.start_date
            : global_duration?.from
            ? global_duration?.from
            : defaultDuration?.from
          : Section_is_locked
          ? section_metadata.start_date
            ? section_metadata?.start_date
            : global_duration?.from
            ? global_duration?.from
            : defaultDuration?.from
          : global_duration?.from
          ? global_duration?.from
          : defaultDuration?.from,
        end_date: widgets_is_locked
          ? widget_metadata?.end_date
            ? widget_metadata?.end_date
            : global_duration?.to
            ? global_duration?.to
            : defaultDuration?.to
          : Section_is_locked
          ? section_metadata?.end_date
            ? section_metadata?.end_date
            : global_duration?.to
            ? global_duration?.to
            : defaultDuration?.to
          : global_duration?.to
          ? global_duration?.to
          : defaultDuration?.to,
        brands: shareBrands
          ? widget_metadata?.is_locked
            ? widget_brands?.columns
              ? widget_brands?.columns
              : section_metadata?.is_locked
              ? section_brands?.columns
                ? section_brands?.columns
                : widget_metadata?.duplicate_for_brands
                ? widget_metadata?.com_brand_ids
                : sectionComprtitorBrandTypeExists
                ? updatedComBrandList
                : defaultBrands
              : widget_metadata?.duplicate_for_brands
              ? widget_metadata?.com_brand_ids
              : sectionComprtitorBrandTypeExists
              ? updatedComBrandList
              : defaultBrands
            : section_metadata?.is_locked
            ? section_brands?.columns
              ? section_brands?.columns
              : widget_metadata?.duplicate_for_brands
              ? widget_metadata?.com_brand_ids
              : sectionComprtitorBrandTypeExists
              ? updatedComBrandList
              : defaultBrands
            : widget_metadata?.duplicate_for_brands
            ? widget_metadata?.com_brand_ids
            : sectionComprtitorBrandTypeExists
            ? updatedComBrandList
            : defaultBrands
          : widgets_is_locked
          ? widget_metadata?.brand_ids || widget_metadata?.brand_groups
            ? widget_brands?.columns
            : Section_is_locked
            ? section_metadata?.brand_ids || section_metadata?.brand_groups
              ? section_brands?.columns
              : widget_metadata?.duplicate_for_brands
              ? widget_metadata?.com_brand_ids
              : sectionComprtitorBrandTypeExists
              ? updatedComBrandList
              : global_brands
              ? global_brands
              : brandlogicalgroup?.length > 0
              ? brandlogicalgroup
              : brands
            : widget_metadata?.duplicate_for_brands
            ? widget_metadata?.com_brand_ids
            : sectionComprtitorBrandTypeExists
            ? updatedComBrandList
            : global_brands
            ? global_brands
            : brandlogicalgroup?.length > 0
            ? brandlogicalgroup
            : brands
          : Section_is_locked
          ? section_metadata?.brand_ids || section_metadata?.brand_groups
            ? section_brands?.columns
            : widget_metadata?.duplicate_for_brands
            ? widget_metadata?.com_brand_ids
            : sectionComprtitorBrandTypeExists
            ? updatedComBrandList
            : global_brands
            ? global_brands
            : brandlogicalgroup?.length > 0
            ? brandlogicalgroup
            : brands
          : widget_metadata?.duplicate_for_brands
          ? widget_metadata?.com_brand_ids
          : sectionComprtitorBrandTypeExists
          ? updatedComBrandList
          : global_brands
          ? global_brands
          : brandlogicalgroup?.length > 0
          ? brandlogicalgroup
          : brands,
        deepdive_on: {
          x_axis: {
            attribute: "authorid",
            value: el?.AuthorAuthorID,
            trace_name: el?.AuthorName,
          },
          y_series: {
            filters: null,
            attribute: "tagid",
            value: el?.Interaction,
            trace_name: "Mention Count",
          },
        },
        filters: filter ? filter : null,
        paneIndex: index,
        panes: panes,
        shareBrands: shareBrands,
        shareTemplateData: {
          ...shareTemplateData,
          isDeepDive: true,
          is_prolific_user_deep_dive: true,
          deep_dive: {
            infoBar: null,
            mentions: null,
            wordcloud: [],
            category: [],
            top_users: [],
            influencers: [],
            source_of_post: [],
            locations: [],
          },
        },
        tabName: "Mentions",
        shareCategory: shareCategory,
        filter_by: widget_metadata?.payload?.filter_by,
        filter_dropdown: widget_metadata?.payload?.filter_dropdown || [],
        filter_by_dropdown: widget_metadata?.payload?.filter_by_dropdown || [],
      };
      graphObject.isBrandModified =
        !shareBrands &&
        (global_brands ||
          (widgets_is_locked &&
            (widget_brands?.columns
              ? widget_brands?.columns?.length
              : widget_brands?.length)) ||
          (Section_is_locked &&
            (section_brands?.columns
              ? section_brands?.columns?.length
              : section_brands?.length)) ||
          widget_metadata?.duplicate_for_brands)
          ? true
          : false;

      dispatch(
        setIsDetailedInsightVisible({
          value: false,
          tab_id: null,
          name: "Mentions",
          key: "1",
        })
      );

      dispatch(
        setTabClick({
          tabName: "mentions",
          state: true,
        })
      );
      dispatch(setDeepDiveObject(graphObject));
      dispatch(setDeepDiveMentionsObject(graphObject));
      dispatch(setDeepDiveInfluencersObject(graphObject));
      shareTemplateData &&
        dispatch({
          type: "SET_SHARE_TEMPLATE_DATA",
          payload: {
            ...shareTemplateData,
            isDeepDive: true,
            is_prolific_user_deep_dive: true,
            deep_dive: {
              infoBar: null,
              mentions: null,
              wordcloud: [],
              category: [],
              top_users: [],
              influencers: [],
              source_of_post: [],
              locations: [],
            },
          },
        });
      !shareBrands && dispatch(setisDeepDive(true, panes, index));

      dispatch(set_WM_DeepDive(true));
      dispatch(setDeepDiveInfoLoader(true));
      dispatch(
        getDeepDive(authParams, graphObject, widget_ids, query?.get("share_id"))
      );

      // handled User Prolifc Deep Dive Flag
      !shareBrands && dispatch(setIsProlificUserDeepDive(true, panes, index));
    }
  };
  const renderFooterActions = () => (
    <>
      <div className={"card__footer__actionWrapper "}>
        {/* MASK UNMASK ICON */}
        {el?.IsMaskedMention &&
        !PdfDownloadStatus &&
        !isDashboardScheduleModal &&
        !PptGeneratingStatus &&
        !isPreviewState &&
        !isReviewCard &&
        (widget_metadata?.chart?.chart_type === "post-card" ||
          mention?.mentions?.result?.graph_type === "post-card" ||
          widgetGraphConfig?.chart_type === "post-card") &&
        (window.location.pathname?.split("/")?.[1] === "widgetMaker" ||
          window.location.pathname?.split("/")?.[1] === "edit-widget" ||
          window.location.pathname?.split("/")?.[1] === "dashboard" ||
          window.location.pathname?.split("/")?.[1] === "pin-dashboard" ||
          authParams?.screen_id) ? (
          <div
            className={`${
              isDarkTheme ? "maskunmask" : "mr-3"
            } d-flex cursor-pointer footer_action`}
            onClick={handleMaskUnMask}
          >
            <Tooltip
              title={idPresentFlag ? "Hide Masked Data" : "View Masked Data"}
            >
              <img
                className={`${
                  isDarkTheme
                    ? "maskedunmaskedpostcard trands"
                    : idPresentFlag
                    ? "trands masked"
                    : "trands unmasked"
                }`}
                src={
                  isDarkTheme
                    ? idPresentFlag
                      ? UnMaskIconCC
                      : MaskIconCC
                    : idPresentFlag
                    ? UnMaskimg
                    : Maskimg
                }
                alt=""
              />
            </Tooltip>
          </div>
        ) : (
          ""
        )}

        {el?.IsDarkPost ? (
          <span className="trands blue-text font-size14 cursor-pointer mr-2">
            <Tooltip title="Dark Post">
              <img
                alt="is Dark Post"
                src={IsDarkPost}
                // width="1.8rem"
                // height="1.8rem"
                className="mr-0 footer_action"
              />
            </Tooltip>
          </span>
        ) : (
          ""
        )}

        {/* Marked Influencers Icon */}
        {el?.AuthorName !== "Anonymous" &&
        !postDetail &&
        !qrChannel &&
        authParams?.screen_id &&
        !isDeepDiveDashboardView &&
        !isTwitterTrendScreen &&
        !(workspace_privileges?.environment === 2) ? (
          <>
            <div
              className="cursor-pointer trands mr-2"
              onClick={() => handleMarkInfluencerModal(el)}
            >
              <Tooltip
                title={
                  <div
                    className="custom_scroll"
                    style={{
                      maxWidth: "270px",
                      maxHeight: "230px",
                      overflow: "auto",
                      scrollBehavior: "smooth",
                    }}
                  >
                    {el?.InfluencerCategoryID &&
                    el?.InfluencerCategoryID !== "NA" &&
                    el?.InfluencerCategoryID !== ""
                      ? el?.InfluencerCategory
                      : "Mark Influencer"}
                  </div>
                }
              >
                <span
                  className={`${isDarkTheme ? "markinfuencerCC" : ""}
                    ${
                      isNetworkTooltip
                        ? "postCardDetails__footer--label"
                        : "cardList__footer-label"
                    }`}
                >
                  {el?.InfluencerCategoryID &&
                  el?.InfluencerCategoryID !== "NA" &&
                  el?.InfluencerCategoryID !== ""
                    ? getDynamicChannelIcon("marked_influencer_yellow")
                    : isDarkTheme
                    ? getDynamicChannelIcon("marked_influencer_blue")
                    : getDynamicChannelIcon(
                        "marked_influencer_command_center_blue"
                      )}
                </span>
                {/* <img
                    src={
                      el?.InfluencerCategoryID &&
                      el?.InfluencerCategoryID !== "NA" &&
                      el?.InfluencerCategoryID !== ""
                        ? MarkInfluencerYellowIcon
                        : isDarkTheme
                        ? MarkInfluencerBlueIconCC
                        : MarkInfluencerBlueIcon
                    }
                    className={`${
                      isDarkTheme ? "markinfuencerCC" : ""
                    }
                    ${
                      isNetworkTooltip
                        ? "postCardDetails__footer--label"
                        : "cardList__footer-label"
                    }`}
                    alt="Marked Influencer Icon"
                  /> */}
              </Tooltip>
              {/* <Tooltip
                  title={
                    el?.InfluencerCategoryID &&
                    el?.InfluencerCategoryID !== "NA" &&
                    el?.InfluencerCategoryID !== ""
                      ? "Marked Influencer"
                      : "Mark Influencer"
                  }
                >
                  {el?.InfluencerCategoryID &&
                  el?.InfluencerCategoryID !== "NA" &&
                  el?.InfluencerCategoryID !== "" ? (
                    // Marked Influencer (Yellow)
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="19.079"
                      viewBox="0 0 20 19.079"
                      className={`${
                        isNetworkTooltip
                          ? "postCardDetails__footer--label"
                          : "cardList__footer-label"
                      }`}
                    >
                      <g id="influencer" transform="translate(0 -11.795)">
                        <g
                          id="Group_28061"
                          data-name="Group 28061"
                          transform="translate(0 11.795)"
                        >
                          <path
                            id="Path_18371"
                            data-name="Path 18371"
                            d="M19.971,19.04a.586.586,0,0,0-.473-.4l-6.2-.9-2.773-5.618a.586.586,0,0,0-1.051,0L6.7,17.74l-6.2.9a.586.586,0,0,0-.325,1l4.486,4.373L3.6,30.189a.586.586,0,0,0,.578.685H15.818a.586.586,0,0,0,.577-.685l-1.059-6.175,4.486-4.373A.586.586,0,0,0,19.971,19.04ZM10,18.4a2.469,2.469,0,1,1-2.469,2.469A2.472,2.472,0,0,1,10,18.4ZM5.688,29.7a4.352,4.352,0,0,1,8.624,0Z"
                            transform="translate(0 -11.795)"
                            fill="#deaa0c"
                          />
                        </g>
                      </g>
                    </svg>
                  ) : isDarkTheme ? (
                    // Default Mark Influencer Icon (Blue, Theme 1)
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="20"
                      height="19.079"
                      viewBox="0 0 20 19.079"
                      className={`${
                        isNetworkTooltip
                          ? "postCardDetails__footer--label"
                          : "cardList__footer-label"
                      }`}
                    >
                      <defs>
                        <clipPath id="clip-path">
                          <rect
                            id="Rectangle_157171"
                            data-name="Rectangle 157171"
                            width="20"
                            height="19.079"
                            fill="#fff"
                          />
                        </clipPath>
                      </defs>
                      <g
                        id="mark_influencer_blue_icon"
                        clip-path="url(#clip-path)"
                      >
                        <path
                          id="Path_73752"
                          data-name="Path 73752"
                          d="M19.971,7.245a.586.586,0,0,0-.473-.4l-6.2-.9L10.525.327a.586.586,0,0,0-1.051,0L6.7,5.945l-6.2.9a.586.586,0,0,0-.325,1l4.486,4.373L3.6,18.394a.586.586,0,0,0,.578.685h11.64a.586.586,0,0,0,.577-.685l-1.059-6.175,4.486-4.373a.586.586,0,0,0,.149-.6ZM10,6.605a2.472,2.472,0,1,1-1.745.724A2.469,2.469,0,0,1,10,6.605Zm-4.312,11.3a4.352,4.352,0,0,1,8.624,0Z"
                          fill="#6a8eff"
                        />
                      </g>
                    </svg>
                  ) : (
                    // Default Mark Influencer Icon (Blue)
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className={`${
                        isNetworkTooltip
                          ? "postCardDetails__footer--label"
                          : "cardList__footer-label"
                      }`}
                    >
                      <g clip-path="url(#clip0_55343_32922)">
                        <path
                          d="M19.9709 7.24505C19.9373 7.14085 19.8752 7.04814 19.7916 6.97744C19.708 6.90674 19.6062 6.86088 19.4979 6.84505L13.2979 5.94505L10.5249 0.327048C10.4765 0.228989 10.4017 0.146425 10.3088 0.0886936C10.2159 0.0309621 10.1088 0.000366211 9.99941 0.000366211C9.89006 0.000366211 9.78289 0.0309621 9.69003 0.0886936C9.59716 0.146425 9.5223 0.228989 9.47391 0.327048L6.69991 5.94505L0.499908 6.84505C0.391587 6.86067 0.289805 6.90632 0.206092 6.97681C0.122378 7.04731 0.0600798 7.13984 0.0262527 7.24392C-0.00757446 7.34801 -0.0115782 7.45948 0.014695 7.56572C0.0409682 7.67197 0.0964682 7.76873 0.174908 7.84505L4.66091 12.218L3.59991 18.394C3.58549 18.4782 3.58962 18.5645 3.61203 18.6468C3.63443 18.7292 3.67457 18.8057 3.72962 18.871C3.78467 18.9362 3.85332 18.9886 3.93075 19.0246C4.00819 19.0605 4.09254 19.0791 4.17791 19.079H15.8179C15.9032 19.079 15.9874 19.0603 16.0647 19.0243C16.1421 18.9882 16.2106 18.9358 16.2655 18.8706C16.3205 18.8053 16.3605 18.7289 16.3829 18.6466C16.4052 18.5643 16.4093 18.4781 16.3949 18.394L15.3359 12.219L19.8219 7.84605C19.9004 7.76978 19.9559 7.67305 19.9823 7.56683C20.0086 7.46062 20.0047 7.34915 19.9709 7.24505ZM9.99991 6.60505C10.4882 6.60505 10.9656 6.74985 11.3716 7.02115C11.7776 7.29245 12.0941 7.67805 12.281 8.1292C12.4678 8.58035 12.5167 9.07679 12.4215 9.55573C12.3262 10.0347 12.0911 10.4746 11.7458 10.8199C11.4005 11.1652 10.9605 11.4003 10.4816 11.4956C10.0026 11.5909 9.50621 11.542 9.05506 11.3551C8.60391 11.1682 8.21831 10.8518 7.94701 10.4458C7.67571 10.0397 7.53091 9.56237 7.53091 9.07405C7.5317 8.41947 7.79208 7.79193 8.25494 7.32908C8.71779 6.86622 9.34533 6.60584 9.99991 6.60505ZM5.68791 17.905C5.83025 16.8625 6.3455 15.9068 7.13827 15.2149C7.93105 14.523 8.94766 14.1417 9.99991 14.1417C11.0522 14.1417 12.0688 14.523 12.8615 15.2149C13.6543 15.9068 14.1696 16.8625 14.3119 17.905H5.68791Z"
                          fill="#4188E4"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_55343_32922">
                          <rect width="20" height="19.079" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  )}
                </Tooltip> */}
            </div>
          </>
        ) : !qrChannel &&
          el?.AuthorName !== "Anonymous" &&
          el?.InfluencerCategoryID &&
          el?.InfluencerCategoryID !== "NA" &&
          el?.InfluencerCategoryID !== "" &&
          el?.InfluencerCategory &&
          el?.InfluencerCategory !== "NA" &&
          el?.InfluencerCategory !== "" ? (
          <>
            <div className="mr-2 custom_scroll">
              <Tooltip
                title={
                  <div
                    className="custom_scroll"
                    style={{
                      maxWidth: "270px",
                      maxHeight: "230px",
                      overflow: "auto",
                      scrollBehavior: "smooth",
                    }}
                  >
                    {el?.InfluencerCategory}
                  </div>
                }
              >
                <img
                  src={MarkInfluencerYellowIcon}
                  className={`${
                    isNetworkTooltip
                      ? "postCardDetails__footer--label"
                      : "cardList__footer-label mb-1"
                  }`}
                  alt="Marked Influencer Icon"
                />
              </Tooltip>
            </div>
          </>
        ) : (
          ""
        )}

        {!commandCenter3DGlobePageId &&
        !commandCenterInfluencersPageId &&
        !qrChannel ? (
          <Tooltip
            title={
              el?.PostURL && el?.PostURL?.trim() && el?.PostURL !== "NA"
                ? "Open Post"
                : "Post URL is not available"
            }
          >
            {el?.PostURL && el?.PostURL?.trim() && el?.PostURL !== "NA" ? (
              <a
                className={`trands blue-text font-size14 cursor-pointer mr-2 ${
                  isNetworkTooltip ? "postCardDetails__footer--label" : ""
                }`}
                href={el?.PostURL}
                target="_blank"
                rel="noreferrer"
                style={{
                  marginTop: "0.2rem",
                }}
              >
                <i class={` fas fa-external-link-alt`} />
              </a>
            ) : (
              <span
                style={{
                  marginTop: "0.2rem",
                  display: "inline-block",
                  opacity: "0.4",
                }}
                className="blue-text font-size14 mr-2"
              >
                <i class={` fas fa-external-link-alt`} />
              </span>
            )}
          </Tooltip>
        ) : (
          ""
        )}

        {el?.TicketID > 0 &&
          !commandCenter3DGlobePageId &&
          !commandCenterInfluencersPageId && (
            <div
              className="ticket_details trands cursor-pointer mr-1"
              onClick={() => onExternal(el?.TicketID, el?.PostBrandID)}
            >
              <Tooltip title="Ticket Details">
                <span>
                  {" "}
                  {isDarkTheme
                    ? getDynamicChannelIcon("deep_link_icon")
                    : getDynamicChannelIcon("deep_link_icon")}
                </span>

                {/* <img
                    src={
                      isDarkTheme
                        ? deepLinkIconCC
                        : deepLinkIcon
                    }
                    className={`${
                      isNetworkTooltip
                        ? "postCardDetails__footer--label"
                        : "cardList__footer-label"
                    }`}
                    alt="Deep Link Icon"
                    style={{ maxWidth: "1.8rem", width: "1.8rem" }}
                  /> */}
              </Tooltip>
            </div>
          )}

        {!(el?.card_type === "User Post" && el?.PlatformID === 5) &&
          !commandCenter3DGlobePageId &&
          !commandCenterInfluencersPageId &&
          !isTwitterTrendScreen &&
          (postDetail || qrChannel ? (
            ""
          ) : (
            <div
              className={`trands  ${
                isPreviewState ? "" : "cursor-pointer mr-2"
              }`}
              onClick={() => !isPreviewState && handleTrends(el)}
            >
              <Tooltip title="Trends">
                <span
                  className={`${
                    isNetworkTooltip
                      ? "postCardDetails__footer--label"
                      : "cardList__footer-label"
                  }`}
                >
                  {" "}
                  {isDarkTheme
                    ? getDynamicIconColor("trends_icon")
                    : getDynamicIconColor("trends_icon")}
                </span>

                {/* <img
                    src={
                      isDarkTheme ? trendsIconCC : trendsIcon
                    }
                    alt="trends Icon"
                  /> */}
              </Tooltip>
            </div>
          ))}

        {/* Delete From Locobuzz */}
        {el?.AuthorName !== "Anonymous" &&
        !postDetail &&
        !qrChannel &&
        authParams?.screen_id &&
        !isDeepDiveDashboardView &&
        !isTwitterTrendScreen &&
        !(workspace_privileges?.environment === 2) ? (
          <>
            <div
              className="cursor-pointer"
              onClick={() => handleDeletePostModal(el)}
            >
              <Tooltip title="Delete from Locobuzz">
                {/* <img
                    src={Delete}
                    className="cardList__footer-label footer_action DeletebuttonCC"
                    alt="Delete from Locobuzz Icon"
                  /> */}
                <span>{getDynamicIconColor("delete_bin_icon")}</span>
              </Tooltip>
            </div>
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );
  return (
    <div>
      <div
        className={`${
          PdfDownloadStatus ? "px-15- ml-15 mr-15" : "p-15"
        } d-flex align-items-center card__footerWrap ${
          el?.PlatformID === 7 || el?.PlatformID === 30
            ? "justify-content-end mb-2"
            : isReviewCard
            ? "justify-content-end"
            : "justify-content-between"
        } ${pantipChannel ? "flex-wrap" : ""}`}
      >
        {commandCenterInfluencersPageId && !el?.isMenstionCountBlock ? (
          <div className="card__footerWrap--inner no--wrap w-100 text-right">
            <Tooltip
              title={"Created Date"}
              className=" d-inline-flex align-items-center"
            >
              <div className="cursor-pointer">
                <img
                  src={Clock}
                  className="cardList__footer-label mr-1"
                  alt="Created Date"
                />
                {el?.CreatedDate}
              </div>
            </Tooltip>
          </div>
        ) : (
          ""
        )}

        {!isReviewCard &&
        !qrChannel &&
        !pantipChannel &&
        el?.PlatformID !== 7 &&
        el?.PlatformID !== 30 &&
        !commandCenter3DGlobePageId &&
        !commandCenterInfluencersPageId ? (
          <div className="d-flex no--wrap w-100">
            <Tooltip
              title={`${
                (el?.PlatformID === 36 ? "Upvotes" : "Likes") +
                ": " +
                el?.NumLikesCount?.toLocaleString()
              }`}
              className="mr-15 d-inline-flex align-items-center"
            >
              <div className="cursor-pointer">
                <div
                  className={`${
                    isNetworkTooltip
                      ? "postCardDetails__footer--label"
                      : "cardList__footer-label"
                  }`}
                >
                  {" "}
                  {el?.PlatformID === 2 || el?.PlatformID === 4
                    ? isDarkTheme
                      ? getDynamicChannelIcon("facebook_like_white")
                      : getDynamicChannelIcon("facebook_like")
                    : el?.PlatformID === 36
                    ? isDarkTheme
                      ? getDynamicChannelIcon("upvote_white")
                      : getDynamicChannelIcon("upvote")
                    : isDarkTheme
                    ? getDynamicChannelIcon("like_white_icon")
                    : getDynamicChannelIcon("like_icon")}
                </div>
                <span
                  className={`${
                    isNetworkTooltip
                      ? "postCardDetails__footer--count"
                      : "cardList__footer-count text-Darkgray"
                  }`}
                >
                  {kFormatter(el?.NumLikesCount)}
                </span>
              </div>
            </Tooltip>
            <Tooltip
              title={`${
                (el?.PlatformID === 36
                  ? "Answers"
                  : el?.PlatformID === 1
                  ? "Replies"
                  : "Comments") +
                ": " +
                (el?.PlatformID === 36
                  ? el?.AnswerCount?.toLocaleString()
                  : el?.NumCommentsCount?.toLocaleString())
              }`}
              className="mr-15 d-inline-flex align-items-center"
            >
              <div className="cursor-pointer">
                {/* isDarktheme ? commentwhite : commetn */}
                {isDarkTheme
                  ? getDynamicChannelIcon("comment_white_icon")
                  : getDynamicChannelIcon("comment_icon")}

                <span
                  className={`${
                    isNetworkTooltip
                      ? "postCardDetails__footer--count"
                      : "cardList__footer-count text-Darkgray"
                  }`}
                >
                  {el?.PlatformID === 36
                    ? kFormatter(el?.AnswerCount)
                    : kFormatter(el?.NumCommentsCount)}
                </span>
              </div>
            </Tooltip>

            {(el?.PlatformID !== 3 ||
              (el?.PlatformID === 3 && el?.card_type === "Brand Post") ||
              (el?.card_type === "User Post" &&
                el?.PlatformID !== 21 &&
                el?.PlatformID !== 70 &&
                el?.PlatformID !== 22)) &&
            !commandCenter3DGlobePageId &&
            !commandCenterInfluencersPageId ? (
              <>
                {el?.PlatformID === 3 && el?.OwnedPublicBrandStatus === 0 ? (
                  ""
                ) : (
                  <Tooltip
                    title={`${
                      (el?.PlatformID === 1
                        ? "Retweets & Quoted Tweets"
                        : "Share") +
                      ": " +
                      el?.NumShareCount?.toLocaleString()
                    }`}
                    className="mr-15 d-inline-flex align-items-center"
                  >
                    <div className="cursor-pointer">
                      <div
                        className={`${
                          isNetworkTooltip
                            ? "postCardDetails__footer--label"
                            : "cardList__footer-label"
                        }`}
                      >
                        {el?.PlatformID === 2
                          ? // FACEBOOK SHARE ICON
                            isDarkTheme
                            ? getDynamicChannelIcon("facebook_share_white")
                            : getDynamicChannelIcon("facebook_share")
                          : el?.PlatformID === 4 || el?.PlatformID === 5
                          ? // YOUTUBE SHARE ICON
                            isDarkTheme
                            ? getDynamicChannelIcon("youtube_share_white")
                            : getDynamicChannelIcon("youtube_share")
                          : el?.PlatformID === 1
                          ? // RETWEET ICON
                            isDarkTheme
                            ? getDynamicChannelIcon("retweet_white_icon")
                            : getDynamicChannelIcon("retweet_icon")
                          : el?.PlatformID === 36
                          ? isDarkTheme
                            ? getDynamicChannelIcon("share_q_white_icon")
                            : getDynamicChannelIcon("share_q_icon")
                          : el?.PlatformID === 3
                          ? // instagram share
                            isDarkTheme
                            ? getDynamicChannelIcon("instagram_share_white")
                            : getDynamicChannelIcon("instagram_share")
                          : // youtube share
                          isDarkTheme
                          ? getDynamicChannelIcon("youtube_share_white")
                          : getDynamicChannelIcon("youtube_share")}
                      </div>

                      {/* className={`${
                        isNetworkTooltip
                          ? "postCardDetails__footer--label"
                          : "cardList__footer-label"
                      }`}
                      alt={el?.PlatformID === 1 ? "Retweet" : "Shares"}
                      style={{ maxHeight: "1.4rem" }}
                    /> */}
                      <span
                        className={`${
                          isNetworkTooltip
                            ? "postCardDetails__footer--count"
                            : "cardList__footer-count text-Darkgray"
                        }`}
                      >
                        {kFormatter(el?.NumShareCount)}
                      </span>
                    </div>
                  </Tooltip>
                )}
              </>
            ) : (
              ""
            )}

            {el?.MediaType === 3 || el?.NumVideoViews > 0 ? (
              <Tooltip
                title={`${"Views: " + el?.NumVideoViews?.toLocaleString()}`}
                className="mr-15 d-inline-flex align-items-center"
              >
                <div className="cursor-pointer">
                  <div
                    className={`${
                      isNetworkTooltip
                        ? "postCardDetails__footer--label"
                        : "cardList__footer-label"
                    }`}
                  >
                    <span>
                      {" "}
                      {(el?.MediaType === 3 ||
                        el?.NumVideoViews > 0 ||
                        el?.PlatformID === 36) &&
                      isDarkTheme
                        ? getDynamicChannelIcon("video_view_white_icon")
                        : getDynamicChannelIcon("video_view_icon")}
                    </span>
                  </div>
                  <span
                    className={`${
                      isNetworkTooltip
                        ? "postCardDetails__footer--count"
                        : "cardList__footer-count text-Darkgray"
                    }`}
                  >
                    {kFormatter(el?.NumVideoViews)}
                  </span>
                </div>
              </Tooltip>
            ) : (
              ""
            )}

            {/* Show For Only TikTok Channel */}
            {el?.PlatformID === 37 &&
            el?.SavedCount >= 0 &&
            el?.SavedCount !== "NA" &&
            el?.SavedCount !== null ? (
              <Tooltip
                title={`${"Saved Count: " + el?.SavedCount?.toLocaleString()}`}
                className="mr-15 d-inline-flex align-items-center"
              >
                <div className="cursor-pointer">
                  <span
                    className={`${
                      isNetworkTooltip
                        ? "postCardDetails__footer--label"
                        : "cardList__footer-label"
                    }`}
                  >
                    {isDarkTheme
                      ? getDynamicIconColor("instagram_save_white")
                      : getDynamicIconColor("instagram_save")}
                  </span>

                  <span
                    className={`${
                      isNetworkTooltip
                        ? "postCardDetails__footer--count"
                        : "cardList__footer-count text-Darkgray"
                    }`}
                  >
                    {kFormatter(el?.SavedCount)}
                  </span>
                </div>
              </Tooltip>
            ) : (
              ""
            )}

            {/* Show For Only Instagram Channel */}
            {el?.PlatformID === 3 &&
            el?.SavedCount >= 0 &&
            el?.SavedCount !== "NA" &&
            el?.SavedCount !== null ? (
              <Tooltip
                title={`${"Post Saves: " + el?.SavedCount?.toLocaleString()}`}
                className="mr-15 d-inline-flex align-items-center"
              >
                <div className="cursor-pointer">
                  {/* <img
                    src={isDarkTheme ? white_Saved : saved}
                    className={`${
                      isNetworkTooltip
                        ? "postCardDetails__footer--label"
                        : "cardList__footer-label"
                    }`}
                    alt="saved"
                  /> */}
                  <span
                    className={`${
                      isNetworkTooltip
                        ? "postCardDetails__footer--label"
                        : "cardList__footer-label"
                    }`}
                  >
                    {isDarkTheme
                      ? getDynamicIconColor("instagram_save_white")
                      : getDynamicIconColor("instagram_save")}
                  </span>

                  <span
                    className={`${
                      isNetworkTooltip
                        ? "postCardDetails__footer--count"
                        : "cardList__footer-count text-Darkgray"
                    }`}
                  >
                    {kFormatter(el?.SavedCount)}
                  </span>
                </div>
              </Tooltip>
            ) : (
              ""
            )}

            {(el?.PlatformID === 2 || el?.PlatformID === 5) &&
              el?.Posttype === "Brand Post" &&
              el?.post_clicks >= 0 && (
                <Tooltip
                  title={`${
                    "Post Clicks: " + el?.post_clicks?.toLocaleString()
                  }`}
                  className="mr-15 d-inline-flex align-items-center"
                >
                  <div className="cursor-pointer">
                    <img
                      src={isDarkTheme ? postClickWhite : postClickBlack}
                      className="cardList__footer-label"
                      alt="Post Clicks"
                    />
                    <span
                      style={{ marginTop: "0.5rem" }}
                      className="cardList__footer-count text-Darkgray"
                    >
                      {kFormatter(el?.post_clicks)}
                    </span>
                  </div>
                </Tooltip>
              )}
            {el?.Interaction > 0 && el?.Interaction && (
              <Tooltip
                title="the total number of interactions with this Author"
                className="mr-15 d-inline-flex align-items-center"
              >
                <div
                  onClick={() => handleProlificUserDeepDive(el)}
                  className="cursor-pointer"
                >
                  <img
                    src={Interaction}
                    className={`${
                      isNetworkTooltip
                        ? "postCardDetails__footer--label"
                        : "cardList__footer-label"
                    }`}
                    alt="Interaction"
                  />
                  <span
                    className={`${
                      isNetworkTooltip
                        ? "postCardDetails__footer--count"
                        : "cardList__footer-count text-Darkgray"
                    }`}
                  >
                    {kFormatter(el?.Interaction)}
                  </span>
                </div>
              </Tooltip>
            )}
            {PdfDownloadStatus &&
            el?.PlatformID === 1 &&
            el?.EmailContentHtml &&
            el?.EmailContentHtml !== "NA" &&
            el?.Followers >= 0 ? (
              <Tooltip
                title="the total number of interactions with this Author"
                className="mr-15 d-inline-flex align-items-center"
              >
                <div className="cursor-pointer">
                  <img
                    src={userFollowers}
                    className="cardList__footer-label"
                    alt="userFollowers"
                  />
                  <span className="cardList__footer-count text-Darkgray">
                    {kFormatter(el?.Followers)}
                  </span>
                </div>
              </Tooltip>
            ) : (
              ""
            )}

            {/* Ad Spend Display */}
            {el?.ad_cost > 0 && el?.ADCostInfoText && (
              <Tooltip
                title={el?.ADCostInfoText}
                className={`mr-15 d-inline-flex align-items-center`}
              >
                <div className="cursor-pointer">
                  <img
                    src={isDarkTheme ? moneyBagIconWhite : moneyBagIcon}
                    className={`${
                      isNetworkTooltip
                        ? "postCardDetails__footer--label"
                        : "cardList__footer-label"
                    }`}
                    alt="Ad Spend"
                    style={{ width: "1.5rem", height: "1.5rem" }}
                  />
                  <span
                    className={`${
                      isNetworkTooltip
                        ? "postCardDetails__footer--count"
                        : "cardList__footer-count text-Darkgray"
                    }`}
                  >
                    {el?.ad_currency && el?.ad_currency !== "NA"
                      ? `${el?.ad_currency} ${kFormatter(el?.ad_cost)}`
                      : kFormatter(el?.ad_cost)}
                  </span>
                </div>
              </Tooltip>
            )}
          </div>
        ) : qrChannel ? (
          <div className="d-flex no--wrap w-100"></div>
        ) : pantipChannel ? (
          <div
            className={`d-flex no--wrap flex-wrap w-100 card__footer__pantipStatsWrapper  ${
              PdfDownloadStatus ? "pdfMode" : ""
            }`}
          >
            {workspace_privileges?.environment === 2 ||
            share_workspace_privileges?.environment === 2 ? (
              <>
                {" "}
                <Tooltip
                  title={`${
                    "Points" + ": " + (el?.PantipPoint || 0)?.toLocaleString()
                  }`}
                  className={`d-inline-flex align-items-center`}
                >
                  <div className="cursor-pointer">
                    <div
                      className={`${
                        isNetworkTooltip
                          ? "postCardDetails__footer--label"
                          : "cardList__footer-label"
                      }`}
                    >
                      {" "}
                      {isDarkTheme
                        ? getDynamicChannelIcon("pantip_point_white_icon")
                        : getDynamicChannelIcon("pantip_point_icon")}
                    </div>
                    <span
                      className={`${
                        isNetworkTooltip
                          ? "postCardDetails__footer--count"
                          : "cardList__footer-count text-Darkgray"
                      }`}
                    >
                      {kFormatter(el?.PantipPoint || 0)}
                    </span>
                  </div>
                </Tooltip>
              </>
            ) : (
              ""
            )}

            <Tooltip
              title={`${
                "Likes" + ": " + (el?.LikeCount || 0)?.toLocaleString()
              }`}
              className={`d-inline-flex align-items-center`}
            >
              <div className="cursor-pointer">
                <div
                  className={`${
                    isNetworkTooltip
                      ? "postCardDetails__footer--label"
                      : "cardList__footer-label"
                  }`}
                >
                  {" "}
                  {isDarkTheme
                    ? getDynamicChannelIcon("pantip_like_white_icon")
                    : getDynamicChannelIcon("pantip_like_icon")}
                </div>
                <span
                  className={`${
                    isNetworkTooltip
                      ? "postCardDetails__footer--count"
                      : "cardList__footer-count text-Darkgray"
                  }`}
                >
                  {kFormatter(el?.LikeCount || 0)}
                </span>
              </div>
            </Tooltip>
            <Tooltip
              title={`${
                "Laugh" + ": " + (el?.LaughCount || 0)?.toLocaleString()
              }`}
              className={`d-inline-flex align-items-center`}
            >
              <div className="cursor-pointer">
                {isDarkTheme
                  ? getDynamicChannelIcon("pantip_laugh_white_icon")
                  : getDynamicChannelIcon("pantip_laugh_icon")}

                <span
                  className={`${
                    isNetworkTooltip
                      ? "postCardDetails__footer--count"
                      : "cardList__footer-count text-Darkgray"
                  }`}
                >
                  {kFormatter(el?.LaughCount || 0)}
                </span>
              </div>
            </Tooltip>
            <Tooltip
              title={`${
                "Love" + ": " + (el?.LoveCount || 0)?.toLocaleString()
              }`}
              className={`d-inline-flex align-items-center`}
            >
              <div className="cursor-pointer">
                {isDarkTheme
                  ? getDynamicChannelIcon("pantip_love_white_icon")
                  : getDynamicChannelIcon("pantip_love_icon")}

                <span
                  className={`${
                    isNetworkTooltip
                      ? "postCardDetails__footer--count"
                      : "cardList__footer-count text-Darkgray"
                  }`}
                >
                  {kFormatter(el?.LoveCount || 0)}
                </span>
              </div>
            </Tooltip>
            <Tooltip
              title={`${
                "Impress" + ": " + (el?.ImpressCount || 0)?.toLocaleString()
              }`}
              className={` d-inline-flex align-items-center`}
            >
              <div className="cursor-pointer">
                {isDarkTheme
                  ? getDynamicChannelIcon("pantip_impress_white_icon")
                  : getDynamicChannelIcon("pantip_impress_icon")}

                <span
                  className={`${
                    isNetworkTooltip
                      ? "postCardDetails__footer--count"
                      : "cardList__footer-count text-Darkgray"
                  }`}
                >
                  {kFormatter(el?.ImpressCount || 0)}
                </span>
              </div>
            </Tooltip>
            <Tooltip
              title={`${
                "Scary" + ": " + (el?.ScaryCount || 0)?.toLocaleString()
              }`}
              className={`d-inline-flex align-items-center`}
            >
              <div className="cursor-pointer">
                {isDarkTheme
                  ? getDynamicChannelIcon("pantip_scary_white_icon")
                  : getDynamicChannelIcon("pantip_scary_icon")}

                <span
                  className={`${
                    isNetworkTooltip
                      ? "postCardDetails__footer--count"
                      : "cardList__footer-count text-Darkgray"
                  }`}
                >
                  {kFormatter(el?.ScaryCount || 0)}
                </span>
              </div>
            </Tooltip>
            <Tooltip
              title={`${"Wow" + ": " + (el?.WowCount || 0)?.toLocaleString()}`}
              className={`d-inline-flex align-items-center`}
            >
              <div className="cursor-pointer">
                {isDarkTheme
                  ? getDynamicChannelIcon("pantip_wow_white_icon")
                  : getDynamicChannelIcon("pantip_wow_icon")}

                <span
                  className={`${
                    isNetworkTooltip
                      ? "postCardDetails__footer--count"
                      : "cardList__footer-count text-Darkgray"
                  }`}
                >
                  {kFormatter(el?.WowCount || 0)}
                </span>
              </div>
            </Tooltip>
            <Tooltip
              title={`${
                "Comments" +
                ": " +
                (el?.NumCommentsCount || 0)?.toLocaleString()
              }`}
              className={`d-inline-flex align-items-center`}
            >
              <div className="cursor-pointer">
                {isDarkTheme
                  ? getDynamicChannelIcon("pantip_comment_white_icon")
                  : getDynamicChannelIcon("pantip_comment_icon")}

                <span
                  className={`${
                    isNetworkTooltip
                      ? "postCardDetails__footer--count"
                      : "cardList__footer-count text-Darkgray"
                  }`}
                >
                  {kFormatter(el?.NumCommentsCount || 0)}
                </span>
              </div>
            </Tooltip>

            {/* Ad Spend Display for Pantip Channel */}
            {el?.ad_cost && el?.ad_cost > 0 && el?.ADCostInfoText && (
              <Tooltip
                title={el?.ADCostInfoText}
                className={`d-inline-flex align-items-center`}
              >
                <div className="cursor-pointer">
                  <img
                    src={isDarkTheme ? moneyBagIconWhite : moneyBagIcon}
                    className={`${
                      isNetworkTooltip
                        ? "postCardDetails__footer--label"
                        : "cardList__footer-label"
                    }`}
                    alt="Ad Spend"
                    style={{ width: "1.5rem", height: "1.5rem" }}
                  />
                  <span
                    className={`${
                      isNetworkTooltip
                        ? "postCardDetails__footer--count"
                        : "cardList__footer-count text-Darkgray"
                    }`}
                  >
                    {el?.ad_currency && el?.ad_currency !== "NA"
                      ? `${el?.ad_currency} ${kFormatter(el?.ad_cost)}`
                      : kFormatter(el?.ad_cost)}
                  </span>
                </div>
              </Tooltip>
            )}
          </div>
        ) : (
          ""
        )}

        {pantipChannel ? (
          <div
            className={`d-flex align-items-center ${
              el?.Interaction > 0 && el?.Interaction
                ? "justify-content-between"
                : "justify-content-end"
            } w-100 mt-1 border-top border-color`}
          >
            <div className="d-flex align-items-center">
              {(workspace_privileges?.environment === 2 ||
                share_workspace_privileges?.environment === 2) &&
                el?.Engagement >= 0 && (
                  <Tooltip
                    title={`${
                      "Engagement" + ": " + el?.Engagement?.toLocaleString()
                    }`}
                    className={`${
                      PdfDownloadStatus ? "mr-2" : "mr-15"
                    }  d-inline-flex align-items-center`}
                  >
                    <div className="cursor-pointer">
                      <div className="text_regular white-space-nowrap mr-1">
                        Engagement
                      </div>
                      {el?.engagement_fx ? (
                        <Tooltip title={el?.Engagement_text}>
                          {" ( "}
                          <img
                            src={fx}
                            style={{ maxWidth: "15px" }}
                            className="cursor-pointer"
                            alt="fx"
                          />
                          {" ) "}
                        </Tooltip>
                      ) : (
                        ""
                      )}{" "}
                      <span
                        className={`${
                          isNetworkTooltip
                            ? "postCardDetails__footer--count"
                            : "cardList__footer-count text-Darkgray"
                        } ${!el?.engagement_fx ? "ml-0" : ""}`}
                      >
                        {": "}
                        {kFormatter(el?.Engagement)}
                      </span>
                    </div>
                  </Tooltip>
                )}

              {el?.Interaction > 0 && el?.Interaction && (
                <Tooltip
                  title="the total number of interactions with this Author"
                  className={`${
                    PdfDownloadStatus ? "mr-2" : "mr-15"
                  }  d-inline-flex align-items-center`}
                >
                  <div
                    onClick={() => handleProlificUserDeepDive(el)}
                    className="cursor-pointer"
                  >
                    <img
                      src={Interaction}
                      className={`${
                        isNetworkTooltip
                          ? "postCardDetails__footer--label"
                          : "cardList__footer-label"
                      }`}
                      alt="Interaction"
                    />
                    <span
                      className={`${
                        isNetworkTooltip
                          ? "postCardDetails__footer--count"
                          : "cardList__footer-count text-Darkgray"
                      }`}
                    >
                      {kFormatter(el?.Interaction)}
                    </span>
                  </div>
                </Tooltip>
              )}
            </div>
            {renderFooterActions()}
          </div>
        ) : (
          <>{renderFooterActions()}</>
        )}
      </div>

      {trandView.modalShow && (
        <Modal
          title={null}
          open={trandView.modalShow}
          closable={false}
          className={`trandsPopup ${
            authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
          }`}
          footer={null}
        >
          <TrandsView
            trendValue={trendValue}
            cardData={trandView.data}
            setTrandView={setTrandView}
            handleTrends={handleTrends}
            isPreviewState={isPreviewState}
            data={data}
            PdfDownloadStatus={PdfDownloadStatus}
            PptGeneratingStatus={PptGeneratingStatus}
            isTrandsView={true}
            deepDive={deepDive}
            section_index={section_index}
            widget_index={widget_index}
            highlightWord={highlightWord}
            isDeepDiveDashboardView={isDeepDiveDashboardView}
          />
        </Modal>
      )}
      {deepLinkModal?.modalShow && (
        <Modal
          title={null}
          open={deepLinkModal?.modalShow}
          style={{ width: "100%", top: "1rem", paddingBottom: "1rem" }}
          onOk={handleDeepLinkOk}
          onCancel={handleDeepLinkCancel}
          width="100%"
          footer={null}
          className={`deepLinkModal ${
            authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
          }`}
        >
          {!deepLinkModal?.url ? (
            <div
              className="loader mx-auto"
              style={{ height: "calc(100vh - 2.6rem)" }}
            >
              <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          ) : (
            deepLinkModal?.url
          )}
        </Modal>
      )}

      {/* Mark Influencer Post Modal */}
      {markInfluencer?.modalShow && (
        <MarkInfluencerPost
          isOpen={markInfluencer?.modalShow}
          setMarkInfluencer={setMarkInfluencer}
          markInfluencer={markInfluencer}
        />
      )}

      {/* Delete Post Modal */}
      {deletePost?.modalShow && (
        <DeletePost
          isOpen={deletePost?.modalShow}
          setDeletePost={setDeletePost}
          deletePost={deletePost}
          deepDive={deepDive}
        />
      )}
    </div>
  );
};

export default React.memo(PostCardFooter, isEqual);
